import styled from '@emotion/styled';

export const AutomationPopupContainer = styled('div', { label: 'AutomationPopupContainer' })`
	display: flex;
	flex-wrap: wrap;
	padding: 20px;
	background-color: white;
    border: 1px solid #bbb;
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
	width: 950px;
	max-height: 1100px;
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 100;
	overflow: auto;
`;

export const AutomationPopupHeader = styled('div', { label: 'AutomationPopupHeader' })`
	display: flex;
	width: 100%;
	justify-content: space-between;
	align-items: center;
`;

export const AutomationPopupControlsContainer = styled('div', { label: 'AutomationPopupControlsContainer' })`
	margin: 15px 0;
	display: flex;
	width: 100%;
	justify-content: center;
	align-items: center;
`;

export const EventsWrapper = styled('div', { label: 'EventsWrapper' })`
	display: flex;
	width: 100%;
	max-height: 900px;
	overflow: auto;
	flex-direction: column;
`;

export const EventWrapper = styled('div', { label: 'EventWrapper' })`
	display: flex;
	width: 100%;
	align-items: center;
	padding: 10px;
	border-bottom: 1px solid #e0e0e0;
`;

export const EventDetails = styled('div', { label: 'EventDetails' })`
	font-size: 14px;
    padding-right: 10px;
  `;
